export function gloading( mtext, times) {
    if(times === undefined ) times = 500;
    var mtextc = (mtext === undefined || mtext == null || mtext == '') ? "拼命操作中ing... " : mtext;
    mtext = mtextc + " " + times;
    const mloading = this.$loading({ // 声明一个loading对象
      lock: true, // 是否锁屏
      text: mtext, // 加载动画的文字
      spinner: 'el-icon-loading', // 引入的loading图标
      background: 'rgba(0, 0, 0, 0.2)' // 背景颜色
    });
 
    setInterval(()=>{
        times--
        mloading.text = mtextc + times ;
        if(times===0){
            clearInterval(timer)
        }
    },1000)
    var timer = times * 1000
    setTimeout(function() { // 设定定时器，超时2S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
      mloading.close() // 关闭遮罩层
    }, timer)
    return mloading
  };



// WEBPACK FOOTER //
// ./src/util/gloading.js